import React, {useMemo} from 'react';
import {Button} from "uikit";
import PlusIcon from "uikit/src/assets/icons/16/plus.svg";
import {PromocodeSchema} from "@/views/Admin/Events/Event/Promocodes/Promocode/Promocode.schema";
import {EmptyPropsInterface} from "@/views/Admin/Events/Event/Promocodes/Empty/Empty.props.interface";
import styles from './Empty.module.scss'
import {PromocodeGroupsServiceSchema} from "@/services/PromocodeGroupsService/PromocodeGroupsService.schema";
import {useQueryRouter} from "@/hooks/useQueryRouter/useQueryRouter";
import {useLocation} from "react-router-dom";

const Empty = ({data, onChange}: EmptyPropsInterface) => {
    const {promocodes, isLoading} = data;
    const {query, set} = useQueryRouter()
    const {search} = useLocation();
    const params = useMemo(() => new URLSearchParams(search), [search]);
    const tabs = data.tabs
    const content = tabs.includes(params.get('content') as string) ? params.get('content') : 'promocodes';
    const current = data[content] || data.promocodes

    const isFilterActive = Object.values(query.filter ?? {}).some(v => v !== '' && v !== null && v !== undefined);
    const isEmpty = Boolean(!current.data.length && !isFilterActive && !isLoading && !promocodes.data.length);
    const isEmptyGlobal = !data.promocodes.data.length && !data.groups.data.length && !isFilterActive && !data.isLoading && !current.isLoading;

    const handleCreatePromocode = () => {
       set({id: -1})
        onChange(prev => ({
            ...prev,
            promocodes: {...prev.promocodes, data: [...prev.promocodes.data, {...PromocodeSchema, isEdit: true}]},
        }))
    }

    const handleCreateGroup = () => {
        set({id: -1})
        onChange(prev => ({
            ...prev,
            promocodes: {
                ...prev.promocodes,
                data: [
                    ...prev.promocodes.data,
                    {
                        ...PromocodeSchema,
                        isEdit: true,
                        promocodeGroup: {
                            ...PromocodeSchema.promocodeGroup,
                            isEdit: true,
                        }
                    }
                ]
            },
            groups: {...prev.groups, data: [...prev.groups.data, {...PromocodeGroupsServiceSchema, isEdit: true}]}
        }))
    }

    return (
        <div className={[styles.container, isEmpty ? styles.isEmpty : null].filter(Boolean).join(' ')}>
            {(isEmpty || !data[content].data.length) && !isFilterActive && <p>
                У события нет&nbsp;
                {content === 'promocodes' && 'промокодов'}
                {content === 'groups' && 'групп'}
            </p>}
            <div className={styles.group} style={{margin: '0 auto'}}>
                {(content === 'promocodes' || isEmptyGlobal) && <Button
                    data-testid="create-promocode-button"
                    type={'primary'}
                    theme={'outline'}
                    size={'small'}
                    htmlType={'button'}
                    className={styles.btn}
                    disabled={isLoading}
                    onClick={handleCreatePromocode}>
                    <PlusIcon/>
                    Промокод
                </Button>}
                {(content === 'groups' || isEmptyGlobal) && <Button
                    data-testid="create-promocode-list-button"
                    type={'primary'}
                    theme={'outline'}
                    size={'small'}
                    htmlType={'button'}
                    className={styles.btn}
                    disabled={isLoading}
                    onClick={handleCreateGroup}>
                    <PlusIcon/>
                    Группа промокодов
                </Button>}
            </div>
        </div>
    );
};

export default Empty;
